import { useTheme } from '@mui/system';
import { Stack, IconButton } from '@mui/material';

import Iconify from 'src/components/iconify';

type Props = {
  rating: number | null;
  onSelectExcitementRating?: (rating: number) => void;
  starSize?: number;
  color?: string;
};

export default function StarRating({
  rating,
  starSize = 20,
  onSelectExcitementRating,
  color = '#E5B80B',
}: Props) {
  const theme = useTheme();
  const value = rating ?? 0;

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      gap={0.5}
      sx={{ '&:hover': onSelectExcitementRating ? { cursor: 'pointer' as const } : {} }}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <IconButton
          key={star}
          disabled={!onSelectExcitementRating}
          onClick={() => onSelectExcitementRating?.(star)}
          sx={{ padding: 0 }}
        >
          <Iconify
            sx={{
              width: starSize,
              height: starSize,
              color: value >= star ? color : theme.palette.text.disabled,
              ':hover': { color },
            }}
            icon={`solar:star-${value >= star ? 'bold' : 'line-duotone'}`}
          />
        </IconButton>
      ))}
    </Stack>
  );
}
